import ReactGADefault from 'react-ga4'

// react-ga4 2.1.0 ships as CommonJS with a NESTED default: at runtime
// `require('react-ga4')` is `{ default: { initialize, send, event, gtag, ... } }`.
// Vite 7's CJS-default interop unwrapped to the inner object; Vite 8's stops one
// level short, so `import ReactGA from 'react-ga4'` yields the outer wrapper and
// `ReactGA.initialize` is `undefined` — which threw at hydration and took down the
// whole client app (root.tsx). Resolve the object that actually carries the methods,
// correct under either interop. Single source — every caller imports ReactGA from here.
const ReactGA: typeof ReactGADefault =
  typeof (ReactGADefault as { initialize?: unknown }).initialize === 'function'
    ? ReactGADefault
    : (ReactGADefault as unknown as { default: typeof ReactGADefault }).default

export default ReactGA
